import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LoginEmailResponse } from '@shared/models';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private http: HttpClient) {}

  sendLoginEmail(email: string): Observable<LoginEmailResponse> {
    return this.http.post<LoginEmailResponse>(`/api/user/auth/app/v1/auth/code/request/`, {
      email: email,
    });
  }
}
